import { configure as configureDataSet, overwriteConfigMergeProps, overwriteDefaultConfig } from 'choerodon-ui/dataset';
import { Formatter, Status, } from 'choerodon-ui/dataset/configure';
import defaults from './default';
overwriteConfigMergeProps(['pagination']);
overwriteDefaultConfig(defaults);
export { Status, Formatter };
export { getConfig, getPrefixCls, getProPrefixCls, getCustomizable, isCustomizable } from './utils';
export default function configure(config, merge = true) {
    configureDataSet(config, merge ? undefined : null);
}
